<template>
<div>
    <!-- Survey Version Selection -->
    <div :class="$style.surveyVersionSection" >
        <div :class="$style.surveyVersionWrapper" v-if="editor.state=='select_survey'">
            <main :class="$style.surveyVersionSelection">
                <p>Select a Survey to edit</p>
                <v-select 
                    class="surveyVersionSelection"
                    :items="list_versions"     
                    v-model="loadVersion"     
                    background-color="white"                  
                    height=30
                    dense
                    outlined
                    flat />
            </main>

            <aside :class="$style.surveyCreationBtn">
                <v-btn
                    color="#7ed4f2"
                    dark
                    depressed
                    @click="createNewSurvey()"
                    >
                    Create a New Survey
                </v-btn>
            </aside>
            </div>
    </div>

    <!-- Survey Questions Section -->
            <div v-if="editor.state=='ready' || editor.state=='changed'">
        <div :class="$style.editorSelectionWrapper">
            <div :class="[$style.editorSelectionCategory, $style.editorSelectionQuestions, {[$style.editorSelectionSelected]: editorSelection === 'question'}]"
                @click="editorSelection = 'question'">
                <span> Questions </span>
            </div>
            <div :class="[$style.editorSelectionCategory, $style.editorSelectionPrompts, {[$style.editorSelectionSelected]: editorSelection === 'prompt'}]"
                @click="editorSelection = 'prompt'">
                <span> Prompts </span>
            </div>
                
            <div :class="[$style.editorSelectionCategory, $style.editorSelectionWidgets, {[$style.editorSelectionSelected]: editorSelection === 'widget'}]"
                @click="editorSelection = 'widget'">
                <span> Widgets </span>
            </div>
        </div>
        <div :class="$style.targetSurveyEditorSection">

            <div v-show="editorSelection === 'question'">
                <!-- Developer Tool & Add question section -->
                <div :class="$style.targetSurveyEditorTools">
                    <v-switch :hide-details="true" class="mx-5" v-model="developerMode">
                        <template slot="label">
                            Developer Tool
                            <v-tooltip bottom color="black"> 
                                <template v-slot:activator="{on, attrs}">
                                    <v-icon style="margin-left: 5px" 
                                        color="black"
                                        small 
                                        v-bind="attrs" 
                                        v-on="on">fas fa-info-circle</v-icon>
                                </template>
                                <span>
                                    It is available to Developers only
                                </span>
                            </v-tooltip>
                        </template>
                    </v-switch>

                    <v-btn small color="primary" depressed class="mx-5" @click="newQuestion">
                        Add a Question
                    </v-btn>
                </div>
                <!-- Questions Section -->
                <draggable 
                    :class="[{[$style.emptyQuestionWrapper]: questions.length == 0}, 'list-group']" 
                    :list="questions" 
                    group="questions" 
                    handle=".handle">
                    <template v-for="(question, index) in questions">
                        <div :class="$style.question_item" :key="`question_item_${index}`">
                            <!-- Position Section-->
                            <div :class="$style.questionItemAsideSection">
                                <aside :class="[$style.questionItemDragSection, 'handle']">
                                    <svgIcon :src="dragIcon" />
                                    <span>Position: {{index + 1}} </span>
                                </aside>
                                <aside :class="$style.questionTrashWrapper">
                                    <v-menu offset-y nudge-left='50'>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                x-small
                                                icon
                                                color="primary"
                                                dark
                                                v-bind="attrs"
                                                v-on="on"
                                    >
                                                <div :class="$style.questionTrashSection">
                                                    <v-badge right>
                                                        <template v-slot:badge>
                                                            <span>{{question_trash.length}}</span>
                                                        </template>
                                                        <!-- <svgIcon :src="trashIcon" /> -->
                                                        <v-icon color="black" mb-1> 
                                                            fas fa-undo
                                                        </v-icon>
                                                    </v-badge>
                                                    <span :class="$style.questionTrashLabel">
                                                        Undo delete
                                                        <v-tooltip top color="black"> 
                                                            <template v-slot:activator="{on, attrs}">
                                                                <v-icon 
                                                                    color="black"
                                                                    x-small 
                                                                    v-bind="attrs" 
                                                                    v-on="on">fas fa-info-circle</v-icon>
                                                            </template>
                                                            <span>
                                                                To undo delete, click “undo delete” then drag and drop the question you wish to undo
                                                            </span>
                                                        </v-tooltip>
                                                    </span>
                                                </div>
                                            </v-btn>
                                        </template>
                                        <v-list v-if="question_trash.length > 0">
                                            <draggable class="list-group" :list="question_trash" group="questions" :move="check_allowUndelete">
                                                <v-list-item v-for="(item, index) in question_trash" :key="'question_trash_item_'+index">
                                                    <div>
                                                        QID: {{item.config.id}} | Type: {{item.config.type}}
                                                        <hr>
                                                        Allow Undelete: {{allowUndelete(item)}}
                                                    </div>
                                                </v-list-item>
                                            </draggable>
                                        </v-list>
                                    </v-menu>
                                </aside>
                                <aside>
                                    <div @click="removeQuestion(index)" style="text-align: center; cursor: pointer;">
                                        <svgIcon :src="trashIcon" /> 
                                        <p style="font-size: 8px;">Delete Question</p>
                                    </div>
                                    <!-- <v-btn
                                        x-small
                                        icon
                                        color="primary"
                                        dark
                                        @click="removeQuestion(index)"
                                        >
                                            <svgIcon :src="trashIcon" />  
                                            <br>  
                                            <p>Remove</p>
                                    </v-btn> -->
                                </aside>
                            </div>
                            <!-- Question Section -->
                            <main :class="$style.questionItemMainSection">
                                <v-icon 
                                    @click="removeQuestion(index);"
                                    color="black" 
                                    small 
                                    :class="$style.deleteIcon">
                                    fa fa-times-circle
                                </v-icon>
                                <v-expansion-panels>
                                    <v-expansion-panel class="custom-icon-rotation">
                                        <!-- Question Body -->
                                        <v-expansion-panel-header 
                                            :style="{'background-color':question.display===true ? 'white' : 'lightgrey'}"
                                            expand-icon="fas fa-angle-right">
                                            <div>
                                                <div :class="$style.questionExpansionHeaderSubContent"> QID: {{question.config.id}} | Type: {{question.config.type}}</div>
                                                <div :class="$style.questionExpansionHeaderContent" v-html="question.config.body.en"/>
                                            </div> 
                                        </v-expansion-panel-header>

                                        <!-- Question Configuration -->
                                        <v-expansion-panel-content :class="$style.questionExpansionContentSection">
                                            <div :class="$style.questionExpansionContentWrapper">
                                                <div :class="$style.questionExpansionContentToggles">
                                                    <div class="mr-5">
                                                        <!-- QID -->
                                                        <v-switch v-model="override.id" hide-details>
                                                            <template v-slot:label>
                                                                <span style="color: black">
                                                                    Manual QID #
                                                                    <v-tooltip top color="black"> 
                                                                        <template v-slot:activator="{on, attrs}">
                                                                            <v-icon style="margin-left: 5px" 
                                                                                color="black"
                                                                                small 
                                                                                v-bind="attrs" 
                                                                                v-on="on">fas fa-info-circle</v-icon>
                                                                        </template>
                                                                        <span>
                                                                            The system will automatically generate QIDs in order. Use this feature if you wish to choose your own QID.
                                                                        </span>
                                                                    </v-tooltip>
                                                                </span>
                                                            </template>
                                                        </v-switch>
                                                        <!-- <edit_qid v-if="override.id" :question="question" :questionMap="questionMap" :rules="rules" :widgets="widgets" :prompts="prompts" @update="update_qid"/> -->
                                                        <edit_qid 
                                                            v-if="override.id"
                                                            :question="question" 
                                                            :questionMap="questionMap" 
                                                            :rules="rules" 
                                                            :widgets="widgets" 
                                                            :prompts="prompts" 
                                                            @update="update_qid"/>
                                                    </div>
                                                    
                                                    <!-- Hidden / Unhidden -->
                                                    <div class="mx-5">
                                                        <v-switch v-model="question.display" hide-details>
                                                            <template v-slot:prepend>
                                                                    <p :class="$style.questionTogglePrependLabel" @click="question.display=false">
                                                                        Hidden
                                                                    </p>
                                                            </template>
                                                            <template v-slot:label>
                                                                <span style="color: black">
                                                                    Unhidden
                                                                </span>
                                                                <v-tooltip top color="black"> 
                                                                    <template v-slot:activator="{on, attrs}">
                                                                                    <v-icon class='ml-5'
                                                                                        color="black"
                                                                            small 
                                                                            v-bind="attrs" 
                                                                            v-on="on">fas fa-info-circle</v-icon>
                                                                    </template>
                                                                    <span>
                                                                        Unhidden questions are always shown. Hidden questions are shown only if one of the rules and its conditions are met.
                                                                    </span>
                                                                </v-tooltip>
                                                            </template>
                                                        </v-switch>
                                                    </div>

                                                    <!-- Required / Not Required -->
                                                    <div class="ml-5">
                                                        <v-switch 
                                                            v-model="question.config.required" 
                                                            label="Required" 
                                                            hide-details>
                                                            <template v-slot:prepend>
                                                                        <p :class="$style.questionTogglePrependLabel" @click="question.config.required=false">
                                                                            Not Required
                                                                        </p>
                                                            </template>
                                                            <template v-slot:label>
                                                                <span style="color: black">Required</span>
                                                            </template>
                                                        </v-switch>
                                                    </div>
                                                </div>

                                                <!-- Question Type -->
                                                <div style="margin-top: 10px;">
                                                    <p style="margin-bottom: 0px;">Question Type</p>
                                                    <v-select v-model="question.config.type" label="Question Type:" :items="question_types" solo @change="onChangeQuestionType(question, $event)"/>
                                                    
                                                        <!-- Number question type -->
                                                    <template v-if="question.config.type === 'Number'">
                                                        <v-row class="mx-1">
                                                            <v-switch
                                                                v-bind:input-value="question.config.type_modifer['Number'] ? question.config.type_modifer['Number']['allowed_decimal'] : false"
                                                                v-on:change="question.config.type_modifer['Number'] ? 
                                                                                question.config.type_modifer['Number']['allowed_decimal'] = $event : 
                                                                                $set(question.config.type_modifer, 'Number', {'allowed_decimal': $event})"
                                                                label="Allow Decimals"
                                                                :true-value='true'
                                                                :false-value="false"
                                                                >
                                                            </v-switch>
                                                        </v-row>                                                       
                                                    </template>
                                                    
                                                        <!-- Restricted Checkbox type -->
                                                    <template v-if="question.config.type === 'CheckboxConstrained'">
                                                        <v-row class="ml-6">
                                                            <v-spacer />
                                                            <v-card class="ml-6">
                                                                <p style="margin-bottom: 0px;color:#6d6d6d;">Min # of picks</p>
                                                                <v-text-field 
                                                                        v-model="question.config.min_num_picks" 
                                                                        type="number" 
                                                                        min="1"
                                                                        :max="218"
                                                                        solo-inverted
                                                                    />
                                                            </v-card>
                                                            <v-card class="ml-9">
                                                                <p style="margin-bottom: 0px;color:#6d6d6d;">
                                                                    Max # of picks
                                                                    <v-tooltip top color="black"> 
                                                                        <template v-slot:activator="{on, attrs}">
                                                                            <v-icon color="#000000" small v-bind="attrs" v-on="on">fas fa-info-circle</v-icon>
                                                                        </template>
                                                                        <span>0 implicitly defaults to nominal number of available options/inputs.</span>
                                                                    </v-tooltip>                                                            
                                                                </p>
                                                                <v-text-field                                                   
                                                                        v-model="question.config.max_num_picks" 
                                                                        type="number" 
                                                                        min="0"
                                                                        :max="218"                                                            
                                                                        solo-inverted
                                                                        style="width:82%"
                                                                    />
                                                            </v-card>
                                                            <v-spacer />
                                                            <v-spacer />
                                                        </v-row>
                                                    </template>
                                                    
                                                        <!-- Rating/LikertScale type -->
                                                    <template v-if="question.config.type === 'Rating'" >
                                                    <v-row justify="center">
                                                        <fieldset>
                                                            <legend class="px-3">Response Set Context</legend>
                                                            <v-list dense>
                                                                <v-list-item-group>
                                                                    <v-list-item
                                                                      v-for="(context, name) in RatingResponseSet"
                                                                      :key="name"
                                                                    >
                                                                        <v-list-item-content>
                                                                            <v-list-item-title><b>{{name}}</b> :: {{contextFormated(context)}}</v-list-item-title>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                </v-list-item-group>
                                                            </v-list>                                                            
                                                        </fieldset>                                                             
                                                    </v-row>
                                                    </template> 
                                                </div>

                                                <!-- Question Rule -->
                                                <edit_rules 
                                                    v-show="question.display===false" 
                                                    @update="update_rules" 
                                                    :display="question.display" 
                                                    :survey_rules="rules" 
                                                    :question_id="question.config.id" 
                                                    :questionMap="questionMap" 
                                                    :developerMode="developerMode"
                                                    style="margin-bottom: 25px;"/>
                                                
                                                <!-- Question Details -->
                                                <div>
                                                    <p style="margin-bottom: 0px;">Question Detail</p>
                                                    <v-expansion-panels v-if="question.config.type">
                                                        <!-- Question Header -->
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header expand-icon="fas fa-angle-right" style="min-height: 40px;">
                                                                <div style="font-size: 12px; font-weight: 500; color: black;">
                                                                    <span>Header</span>
                                                                    <v-tooltip right color="black" class='ml-2' content-class="questionDetailTooltip"> 
                                                                        <template v-slot:activator="{on, attrs}">
                                                                            <v-icon
                                                                                color="black"
                                                                                small 
                                                                                v-bind="attrs" 
                                                                                v-on="on">fas fa-info-circle</v-icon>
                                                                        </template>
                                                                        <span>
                                                                            A "header" will appear bigger and bolder above the question text.
                                                                            <br>
                                                                            Example:<br>
                                                                            <img :src="imgHeaderExample" style="margin-top: 0; max-height: unset" />
                                                                        </span>
                                                                    </v-tooltip>
                                                                </div>
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <edit_content @update="update_content" :question="question" target="header" :languages="languages"/>
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>

                                                            <!-- Question Text -->
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header expand-icon="fas fa-angle-right" style="min-height: 40px;">
                                                                <div style="font-size: 12px; font-weight: 500; color: black;">
                                                                    Question Text
                                                                    <v-tooltip right color="black" class='ml-2'> 
                                                                        <template v-slot:activator="{on, attrs}">
                                                                            <v-icon
                                                                                color="black"
                                                                                small 
                                                                                v-bind="attrs" 
                                                                                v-on="on">fas fa-info-circle</v-icon>
                                                                        </template>
                                                                        <span>
                                                                            The question that will be displayed.
                                                                            <br>
                                                                            Example:<br>
                                                                            <img :src="imgQuestionTextExample" style="margin-top: 0; max-height: unset" />
                                                                        </span>
                                                                    </v-tooltip>
                                                                </div>
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <edit_content @update="update_content" :question="question" target="body" :languages="languages"/>
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>

                                                        <!-- Question Subtext -->
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header expand-icon="fas fa-angle-right" style="min-height: 40px;">
                                                                <div style="font-size: 12px; font-weight: 500; color: black;">
                                                                    Subtext
                                                                    <v-tooltip right color="black" class='ml-2'> 
                                                                        <template v-slot:activator="{on, attrs}">
                                                                            <v-icon
                                                                                color="black"
                                                                                small 
                                                                                v-bind="attrs" 
                                                                                v-on="on">fas fa-info-circle</v-icon>
                                                                        </template>
                                                                        <span>
                                                                            The text that will be displayed below the question.
                                                                            <br>
                                                                            Example:<br>
                                                                            <img :src="imgSubtextExample" style="margin-top: 0; max-height: unset" />
                                                                        </span>
                                                                    </v-tooltip>
                                                                </div>
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <edit_content
                                                                    @update="update_content"
                                                                    :question="question"
                                                                    :question_type="question.config.type"
                                                                    target="subtext"
                                                                    :languages="languages"
                                                                    :key="'subtext_'+index"
                                                                    :min_picks="question.config.min_num_picks"
                                                                    />
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>

                                                        <!-- QUestion Group -->
                                                        <v-expansion-panel>
                                                            <edit_groups @update="update_groups" :array="question.config.groups" :question="question" type="group" :languages="languages"/>
                                                        </v-expansion-panel>

                                                        <!-- Question Footer -->
                                                        <v-expansion-panel>
                                                                <v-expansion-panel-header expand-icon="fas fa-angle-right" style="min-height: 40px;">
                                                                    <div style="font-size: 12px; font-weight: 500; color: black;">
                                                                        Footer
                                                                        <v-tooltip right color="black" class='ml-2'> 
                                                                            <template v-slot:activator="{on, attrs}">
                                                                                <v-icon
                                                                                    color="black"
                                                                                    small 
                                                                                    v-bind="attrs" 
                                                                                    v-on="on">fas fa-info-circle</v-icon>
                                                                            </template>
                                                                            <span>
                                                                                Footers are rarely used. They will appear below the question and its inputs.
                                                                            </span>
                                                                        </v-tooltip>
                                                                    </div>
                                                                </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <edit_content @update="update_content" :question="question" target="footer" :languages="languages"/>
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>

                                                        <!-- Question Actions -->
                                                        <v-expansion-panel v-if="developerMode == true">
                                                            <v-expansion-panel-header expand-icon="fas fa-angle-right" style="min-height: 40px;">
                                                                <div style="font-size: 12px; font-weight: 500; color: black;">
                                                                    Actions [Advanced]
                                                                    <v-tooltip right color="black" class='ml-2'> 
                                                                        <template v-slot:activator="{on, attrs}">
                                                                            <v-icon
                                                                                color="black"
                                                                                small 
                                                                                v-bind="attrs" 
                                                                                v-on="on">fas fa-info-circle</v-icon>
                                                                        </template>
                                                                        <span></span>
                                                                    </v-tooltip>
                                                                </div>
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <v-textarea v-model="question.actions" label="Advanced: Function Wrapper (question, questionMap) - remember to consider null values"/>
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                </div>
                                            </div>                                                                                                                                                       
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </main>
                        </div>
                    </template>
                </draggable>

                <div :class="$style.targetSurveyEditorTools">
                    <v-btn color="primary" depressed class="mx-5" @click="newQuestion">
                        Add a Question
                    </v-btn>
                </div>
            </div>

            <div v-show="editorSelection === 'prompt'">
                <edit_prompts 
                    @update="update_prompts" 
                    @updatedDeveloperMode="updatedDeveloperMode"
                    :prompts="prompts" 
                    :languages="languages" 
                    :questions="questions" 
                    :questionMap="questionMap"
                    :developerMode="developerMode"/>
            </div>

            <div v-show="editorSelection === 'widget'">
                <edit_widgets 
                    @update="update_widgets" 
                    @updatedDeveloperMode="updatedDeveloperMode"
                    :widgets="widgets" 
                    :languages="languages" 
                    :questions="questions" 
                    :questionMap="questionMap"
                    :developerMode="developerMode" />
            </div>
        </div>
    </div>
    <div style="display: flex; flex-direction: row; align-item: center; padding-bottom: 15px; justify-content: center">
        <v-btn depressed color="#c8c8c8" @click="close" class='mr-3'>Close</v-btn> 
        <template v-if="editor.state!='select_survey'">
            <v-btn depressed color="#c8c8c8" @click="editor.service.send('idle')" class='mr-5' >Restart Editor</v-btn>
        </template>
        <v-btn depressed color="primary" @click="save" class='mr-3'>Save</v-btn>
        <v-btn depressed color="#ff5252" @click="preview" dark>Preview</v-btn>
            </div>
</div>
</template>

<script>
import { Machine, interpret, assign, sendParent, spawn, raise, actions, send, respond} from 'xstate';
import draggable from "vuedraggable";
import languageCodes from "@/components/UI/languageCodes.js";
import edit_qid from "./edit_qid.vue";
import edit_prompts from "./edit_prompts.vue";
import edit_widgets from "./edit_widgets.vue";
import edit_content from "./edit_content.vue";
import edit_groups from './edit_groups.vue';
import edit_rules from './edit_rules.vue';

import svgIcon from '@/components/svg/svg_icon.vue';
import dragIcon from '@/assets/images/icons/drag.svg';
import trashIcon from '@/assets/images/icons/trash.svg';
import imgHeaderExample from '@/assets/images/surveyEditor/header.png';
import imgQuestionTextExample from '@/assets/images/surveyEditor/question_text.png';
import imgSubtextExample from '@/assets/images/surveyEditor/subtext.png';

export default {
    name: 'survey-editor',
    components: {
        draggable,
        edit_qid,
        edit_prompts,
        edit_widgets,
        edit_content,
        edit_groups,
        edit_rules,
        svgIcon
    },
    props: {
        survey_state: {
            type: String,
            required: true
        },
        survey_id: {
            type: Number,
            required: true
        }
    },
    created: function(){
        var component = this;
        const editor_machine = new Machine({
            id: 'editor',
            initial: 'idle',
            context: {
                survey_id: null
            },
            states: {
                idle: {
                    invoke: {
                        src: (context, event) => new Promise((resolve, reject)=>{
                            switch(component.survey_state){
                                case"editing":
                                    var action='survey';
                                    var call='getVersions';
                                    component.$sendRequest({
                                        action: action,
                                        call: call,
                                        data: {
                                            survey_id: component.survey_id
                                        }
                                    }).then(function(response){
                                        var reply = response.data[action][call];
                                        var versions = [];

                                        var storage = window.localStorage;
                                        var cache = storage.getItem('survey_editor_cache');

                                        if(cache){
                                            cache = JSON.parse(cache);
                                            var survey = cache[component.survey_id];
                                            if(survey){
                                                survey.saved = survey.saved ? survey.saved : false;
                                                if(survey.saved===false){
                                                    versions.push({
                                                        data: {
                                                            questions: survey.questions,
                                                            rules: survey.rules,
                                                            prompts: survey.prompts
                                                        },
                                                        id: 'local cache',
                                                        saved_by: '-',
                                                        version_id: '-',
                                                        timestamp: '-'
                                                    })
                                                }
                                                component.edit_base_version_id = survey.edit_base_version_id;
                                            }
                                        }                                
                                        
                                        var results = reply.results;
                                        for(let i=0; i<results.length; i++){
                                            versions.push(component.$root.parseJSON(results[i]));
                                        };
                                        component.versions = versions;
                                        resolve();
                                    },function(){
                                        reject();
                                    });                            

                                break;

                                case"editing_cache":
                                    var versions = [];

                                    var storage = window.localStorage;
                                    var cache = storage.getItem('survey_editor_cache');

                                    if(cache){
                                        cache = JSON.parse(cache);
                                        var survey = cache[component.survey_id];
                                        if(survey){
                                            survey.saved = survey.saved ? survey.saved : false;
                                            if(survey.saved===false){
                                                versions.push({
                                                    data: {
                                                        questions: survey.questions,
                                                        rules: survey.rules,
                                                        prompts: survey.prompts,
                                                        widgets: survey.widgets ? survey.widgets: []
                                                    },
                                                    timestamp: 'N/A',
                                                    id: survey.edit_base_version_id
                                                })
                                            }
                                        }
                                    }
                                    component.versions = versions;
                                    resolve();
                                break;
                            }
                        }),
                        onDone: {
                            target: 'select_survey'
                        },
                        onError: {
                            target: 'error_select_survey'
                        }
                    },
                    on: {
                        select_survey: 'select_survey'
                    }
                },
                select_survey: {
                    invoke: {
                        src: (context, event) => new Promise((resolve, reject)=>{
                            if(component.versions.length == 1){
                                component.loadVersion=0;
                                resolve()
                            }
                        }),
                        onDone: {
                            target: 'load_survey'
                        },
                        onError: {
                            target: 'error_load_survey'
                        }
                    },
                    on: {
                        load_survey: 'load_survey',
                        create_survey: 'create_survey'
                    }
                },
                error_select_survey: {
                    on: {idle: 'idle'}
                },
                create_survey: {
                    invoke: {
                        id: 'create_survey',
                        src: () => new Promise((resolve)=> {
                            component.questions = [];
                            component.rules = {
                                display: {}
                            };
                            component.prompts = [];
                            component.widgets = [];
                            component.saved = false;
                            resolve();
                        }),
                        onDone: {
                            target: 'is_saved'
                        },
                        onError: {
                            target: 'error_load_survey'
                        }

                    }
                },
                load_survey: {
                    invoke: {
                        id: 'load_survey',
                        src: (context, event) => new Promise((resolve, reject)=>{
                            var record = component.versions[component.loadVersion];
                            component.questions = record.data.questions;
                            component.rules = record.data.rules;
                            component.prompts = record.data.prompts;
                            component.widgets = record.data.widgets ? record.data.widgets : [];
                            component.edit_base_version_id = record.id;
                            component.saved = record.id ? true : false;
                            resolve();
                        }),
                        onDone: {
                            target: 'is_saved'
                        },
                        onError: {
                            target: 'error_load_survey'
                        }
                    }
                },
                    error_load_survey: {
                        on: {idle: 'idle'}
                    },
                is_saved: {
                    invoke: {
                        id: 'is_saved',
                        src: (context, event) => new Promise((resolve, reject)=>{
                            if(component.saved===true){
                                resolve();
                            }else{
                                reject();
                            }
                        }),
                        onDone: {
                            target: 'ready'
                        },
                        onError: {
                            target: 'changed'
                        }
                    }
                },
                save: {
                    invoke: {
                        src: (context, event) => new Promise((resolve,reject)=>{
                            var action='survey';
                            var call='saveSurvey';
                            component.$sendRequest({
                                action: action,
                                call: call,
                                data: {
                                    survey: {
                                        questions: component.questions,
                                        rules: component.rules,
                                        prompts: component.prompts,
                                        widgets: component.widgets ? component.widgets : []
                                    },
                                    survey_id: component.survey_id,
                                    program_id: component.program_id,
                                }
                            }).then(function(response){
                                var reply = response.data[action][call];

                                if(reply.saved){
                                    component.saved = true;
                                    component.cache_survey();
                                    resolve();
                                }else{
                                    reject(response);
                                }
                            });
                        }),
                        onDone: {
                            target: 'ready'                            
                        },
                        onError: {
                            target: 'error_save'
                        }
                    }
                },
                error_save: {
                    on: {
                        idle: 'idle',
                        ready: 'ready',
                        save: 'save'
                    }
                },
                ready: {
                    invoke: {
                        src: (context, event) => function(){
                            for(let i=0; i<component.questions.length; i++){
                                var question = component.questions[i];

                                var groups = question.config.groups;
                                for(let g=0; g<groups.length; g++){
                                    var group = groups[g];

                                    
                                    if(group.label.length==0){
                                        group.label = {};
                                    }
                                }

                            }


                        }
                    },
                    on: {
                        idle: 'idle',
                        changed: 'changed',
                        load_survey: 'load_survey',
                    }
                },
                changed: {
                    invoke: {
                        id: 'changed',
                        src: (context, event) => function(){
                            component.saved = false;
                            component.cache_survey();
                        }
                    },
                    on: {
                        idle: 'idle',
                        save: 'save',
                        changed: 'changed'
                    }
                }
            }
        });
        
        var editor = {
            machine: editor_machine,
            service: interpret(editor_machine),
            state: editor_machine.initialState,
            context: editor_machine.context
        }
        editor.service.onTransition(state => {
            editor.state = state.value;
            editor.context = state.context
        }).start();

        this.editor = editor;
    },
    mounted: function(){
        this.editor.context.survey_id = this.survey_id;  
        // this.editor.service.send('select_survey');
        
    },
    data: function(){
        return {
            question_types: ['Radio','RadioTable','Checkbox','CheckboxConstrained','Select','SelectTable','Number','Percentage','Ranking','DatePicker','TextArea','Rating'],
            editor: null,
            prompts: [],
            widgets: [],
            questions: [],
            question_trash: [],
            rules: {
                display: {}
            },
            cache_timer: null,
            saved: false,
            versions: null,
            loadVersion: null,
            override: {
                id: false
            },
            edit_base_version_id: null,
            show: true,
            developerMode: false,
            editorSelection: 'question',
            RatingResponseSet: {
                Frequency: ['Never','Rarely','Sometimes','Often','Always'],
                Quality: ['Very poor','Poor','Fair','Good','Excellent'],
                Intensity: ['None','Very mild','Mild','Moderate','Severe'],
                Agreement: ['Strongly disagree','Disagree','Neither agree nor disagree','Agree','Strongly agree'],
                Approval: ['Strongly disapprove','Disapprove','Neutral','Approve','Strongly approve'],
                Awareness: ['Not at all aware','Slightly aware','Moderately aware','Very aware','Extremely aware'],
                Importance: ['Not at all important','Slightly important','Moderately important','Very important','Extremely important'],
                Familiarity: ['Not at all familiar','Slightly familiar','Moderately familiar','Very familiar','Extremely familiar'],
                Satisfaction: ['Not at satisfied','Slightly satisfied','Moderately satisfied','Very satisfied','Completely satisfied'],
                Performance: ['Far bellow standards','Bellow standards','Meets standards','Above standards','Far above standards']
            },
        }
    },
    methods: {
        contextFormated: function(contextArr){
            let output = '';
            if (contextArr.length>0){
                output = "(Rate from 1 to " + contextArr.length + " where ";
                for(let i=0; i<contextArr.length; i++){
                    let weight = i+1;
                    output +=  weight + "-" + contextArr[i];
                    output += i==contextArr.length-1 ? ".)" : ", ";                    
                }
            }
            
            return output;
        },
        onChangeQuestionType: function(question, event){
            if (event==="CheckboxConstrained"){
                question.config.max_num_picks = 0;
                question.config.min_num_picks = 1;
            }
            else {
                question.config.max_num_picks = null;
                question.config.min_num_picks = null;
            }
        },
        close: function(){
            this.$emit('close');
        },
        save: function(){
            this.editor.service.send('save');
        },
        preview: function(){
            this.$emit('preview');
        },
        newQuestion: function(){
            var generate_inputs = function(number){
                var output = []
                
                for(let i=1; i<=number; i++){
                    output.push(
                        {
                            id: i,
                            position: i,
                            value: i,
                            label: {
                                en: "Input Number: "+i,
                                es: "Inputo Numero: "+i
                            },
                            exclusive: (i==number) ? true : false,
                            disabled: (i==3) ? true : false,
                            other: i==number-1 ? true : false
                        }              
                    )
                }

                return output;
            }
            var languages = this.languages;
            var generate_questionConfig = function(type, id, position){
                var output = {
                    config:{
                        type: type, 
                        id: id, 
                        position: position,
                        header: {},
                        body: {},
                        subtext: {},
                        footer: {},
                        groups: [],
                        required: true,
                        type_modifer: {
                            DatePicker: {
                                allowed_dates: null
                            },
                            Number: {
                                allowed_decimal: false
                            }
                        },
                    },
                    display: true,
                    display_triggers:[],
                    value: null,
                    actions: null
                };

                for(let l=0; l<languages.length; l++){
                    var language = languages[l];
                    output.config.header[language.code] = null;
                    output.config.body[language.code] = null;
                    output.config.subtext[language.code] = null;
                    output.config.footer[language.code] = null;
                }

                switch(type){
                    case"Checkbox":
                         
                    break;
                }

                return output
            }

            var qid = this.newID();
            
            this.questions.push(generate_questionConfig( null , qid, qid ) )
        },
        newID: function(){
            var qids = {};
            for(let i=0; i<this.questions.length; i++){
                var question = this.questions[i];
                qids[question.config.id] = true;
            }

            var qid = 1;
            for(let i=0; i<this.questions.length; i++){
                var question = this.questions[i];
                if(!qids[qid]){
                    break;
                }
                qid++;
            }


            return qid;
        },
        update_qid: function(data){
            this.questionMap[data.current_qid].config.id = data.new_qid;
        },
        allowUndelete: function(question){
            var allow = typeof this.questionMap[question.config.id] == 'undefined';
            
            return allow;
        },
        check_allowUndelete: function(event){
            return this.allowUndelete(event.draggedContext.element);
        },
        update_prompts: function(data){
            this.prompts = data.prompts;
            this.editor.service.send('changed')
        },
        update_widgets: function(data){
            this.widgets = data.widgets;
            this.editor.service.send('changed')
        },
        update_content: function(data){
            this.questionMap[data.question_id].config[data.target] = data.content;
        },
        update_groups: function(data){
            this.questionMap[data.question_id].config.groups = data.groups;
        },
        cache_survey: function(){
            var self = this;

            clearTimeout(self.cache_timer);
            self.cache_timer = setTimeout(function(){
                var storage = window.localStorage;

                var cache = storage.getItem('survey_editor_cache');
                if(cache){
                    cache = JSON.parse(cache);
                }else{
                    cache = {};
                }

                var questions = JSON.stringify(self.questions);
                questions = JSON.parse(questions);

                cache[self.editor.context.survey_id] = {
                    questions: questions,
                    rules: self.rules,
                    saved: self.saved,
                    prompts: self.prompts,
                    widgets: self.widgets,
                    edit_base_version_id: self.edit_base_version_id
                };
                
                storage.setItem('survey_editor_cache',JSON.stringify(cache));
            },1000)
        },
        update_rules: function(data){
            if(data.rules){
                this.rules.display[data.question_id] = data.rules;
            }else{
                delete this.rules.display[data.question_id];
            }
            var display = {}
            for(let i in this.rules.display){
                if(this.rules.display[i]){
                    display[i] = this.rules.display[i];
                }
            }
            this.rules.display = display;
            this.editor.service.send("changed");
        },
        createNewSurvey: function() {
            this.editor.service.send("create_survey");
        },
        removeQuestion: function(question_index) {
            this.question_trash.push(this.questions[question_index]);
            this.questions.splice(question_index, 1);
        },
        updatedDeveloperMode: function(newValue) {
            this.developerMode = newValue;
        }
    },
    computed: {
        questionMap: function(){
            var questionMap = {};
            for(let i=0; i<this.questions.length; i++){
                var question = this.questions[i];
                questionMap[question.config.id] = question;
            }

            return questionMap;
        },
        languages: function(){
            var languages = [];
            for(let i in this.$store.getters.library.languages){
                languages.push({name: languageCodes[i].name, code:i});
            }
            return languages;
        },
        list_versions: function(){
            var list = [];
            if(this.versions){
                for(let i=0; i<this.versions.length; i++){
                    var item = this.versions[i];
                    list.push({
                        text: 'Version: '+(this.versions.length-i)+' | Version ID: ['+item.id+'] | SAVED BY USER ID: ['+item.saved_by+'] | TIMESTAMP: '+item.timestamp,
                        value: i
                    });
                }
            }            


            return list;
        },
        dragIcon: function() {
            return dragIcon;
        },
        imgHeaderExample: function() {
            return imgHeaderExample;
        },
        imgQuestionTextExample: function() {
            return imgQuestionTextExample;
        },
        imgSubtextExample: function() {
            return imgSubtextExample;
        },
        trashIcon: function() {
            return trashIcon;
        }
    },
    watch: {
        questions: {
            deep: true,
            handler: function(after,before){
                this.cache_survey();
                if(this.editor.state=='ready'){
                    this.editor.service.send("changed")
                }
            }
        },
        questionMap: {
            deep: true,
            handler: function(after,before){
                this.cache_survey();
                if(this.editor.state=='ready'){
                    this.editor.service.send("changed")
                }
            }
        },
        loadVersion: function(after, before){
            this.editor.service.send("load_survey");
        },
        edit_base_version_id: function(after, before){
            return this.$emit('update:edit_base_version_id', this.edit_base_version_id);
        }
    }
}
</script>

<style module>
.surveyVersionSection {
    padding: 20px 0;
    background-color: #fafafa;
}

.surveyVersionWrapper {
    width: 80%; 
    margin: 0 auto; 
    display: flex; 
    flex-direction: row; 
    flex-flow: wrap; 
    align-items: flex-end; 
    justify-items: center;
}

.surveyVersionSelection {
    flex: 1 50%;
}

.surveyVersionSection p {
    margin-bottom: 0px !important; 
    color: black;
}

.surveyCreationBtn {
    flex: 1 auto; 
    text-align: center;
}

.list_container{
    float: left;
}

.trash{
    position: fixed; 
    top: 100px; 
    right: 15px; 
}

.targetSurveyEditorSection {
    width: 95%; 
    margin: 0 auto; 
    background-color: #dfe0e0;
    border-top: 5px solid #1b77d2;
    border-radius: 15px;
}

.targetSurveyEditorTools {
    display: flex; 
    flex-direction: row; 
    align-items: flex-end; 
    justify-content: flex-end;
    padding: 20px 0;
}

.question_item{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    position: relative;
    margin: 15px auto;
    background-color: inherit;
    width: 98%
}

.handle{
    position: relative;
    left: 5px;
    top: 25px;
    font-size: 12pt;
    z-index: 100;
}

.questionItemAsideSection {
    width: 7%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
}

.questionItemDragSection {
    cursor: grab; 
    padding: 15px 5px 0 5px; 
    display: flex; 
    flex-direction: column; 
    text-align: center; 
    width: 100%;
    height: 65px; 
    background-color: #eeeeee;
    cursor: grab;
    justify-content: center;
}

.questionItemDragSection:active {
    cursor: grabbing;
}

.questionItemDragSection span {
    font-size: 10px; 
    color: #82B1FF;
}

.questionTrashWrapper {
    width: 100%;
    padding: 20px 0;
    text-align: center;
}

.questionTrashSection {
    display: flex; 
    flex-direction: column; 
    align-items: center; 
    justify-content: center;
    cursor: pointer;
}

.questionTrashLabel {
    font-size: 8px; 
    color: black; 
    font-weight: 400; 
    text-transform: initial;
}

.questionItemMainSection {
    width: 93%;
    position: relative;
}

.questionExpansionHeaderSubContent {
    font-size: 0.7em; 
    color: #A9A9A9;
}

.questionExpansionHeaderContent {
    margin-top: 5px; 
    font-size: 1em;
}

.questionExpansionContentSection {
    background-color: white; 
    border-top: 1px solid #E5E5E5; 
    padding-top: 15px;
}

.questionExpansionContentWrapper {
    border: 1px solid #d0d0d0; 
    background-color: #E0E0E0; 
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); 
    border-radius: 10px; 
    padding: 25px;
}

.questionExpansionContentToggles {
    display: flex; 
    flex-flow: row wrap; 
    align-items: center;
}

.questionTogglePrependLabel {
    color:black; 
    margin-top: 5px; 
    cursor:pointer; 
    margin-bottom: 0px !important;
}

.deleteIcon {
    position: absolute; 
    top: -9px; 
    right: -5px; 
    z-index:2;
    cursor: pointer;
}

.editorSelectionWrapper {
    width: 100%; 
    display: flex; 
    flex-direction: row; 
    justify-content: center;
    align-items: center;
}

.editorSelectionCategory {
    width: 8%; 
    padding: 5px 0px; 
    border: 1px solid #1b77d2; 
    text-align: center; 
    color: #a7a7a7;
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: 400;
}

.editorSelectionSelected {
    background-color: #1b77d2;
    color: white;
}

.editorSelectionQuestions {
    border-radius: 15px 0 0 0;
}

.editorSelectionPrompts {
    border-radius: 0;
}

.editorSelectionWidgets {
    border-radius: 0 15px 0 0;
}

.emptyQuestionWrapper {
    border: 1px dashed silver;
    height: 50px;
    margin-top: 15px;
    padding-bottom: 15px;
}

.emptyQuestionWrapper:after {
    content: 'Drag Question to here...';
    margin: 0 auto;
    vertical-align: -50%;
    text-align: center;
    padding: 0 15px;
}
</style>

<style>
.surveyVersionSelection .v-input__control {
    align-items: center;
    justify-content: center;
}

.surveyVersionSelection .v-input__slot, .adminModeSelection .v-input__slot {
    margin-bottom: 0px;
}
.surveyVersionSelection .v-text-field__details, .adminModeSelection .v-text-field__details{
    display: none;
}

.surveyVersionSelection .v-input__slot, .adminModeSelection .v-input__slot {
    min-height: 0px !important;
}

.surveyVersionSelection .v-input__append-inner, .adminModeSelection .v-input__append-inner {
    margin-top: 3px !important;
}

.custom-icon-rotation .v-expansion-panel-header--active .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate) .v-icon  {
    transform: rotate(90deg) !important;

}

.questionDetailTooltip {
    background-color: purple !important;
}
</style>